import PrivacyPolicy from "../components/Privacy Policy/PrivacyPolicy";

export default {
  name: "PrivacyPolicy",
  component: PrivacyPolicy,
  url: "/privacy-policy",
  exact: true,
  requireAuth: true
};